import React from "react";
import {
  Bot,
  BrainCircuit,
  CircleHelp,
  Clock3,
  Kanban,
  Copy,
  FileText,
  GitBranch,
  Image,
  List,
  MessageSquareText,
  Mic,
  Shuffle,
  Tags,
  Ticket,
  Trash2,
  Type,
  Video,
  Webhook,
  Workflow,
} from "lucide-react";

const iconSize = (style, fallback = 16) => {
  if (!style) return fallback;
  return style.width || style.height || style.fontSize || fallback;
};

const createIcon = (Icon, fallbackSize = 16) => ({ style, size, strokeWidth = 1.8, ...props }) => {
  const { fontSize, ...iconStyle } = style || {};

  return (
    <Icon
      size={size || fontSize || iconSize(iconStyle, fallbackSize)}
      strokeWidth={strokeWidth}
      style={iconStyle}
      {...props}
    />
  );
};

export const ContentIcon = createIcon(MessageSquareText);
export const MenuIcon = createIcon(List);
export const RandomizerIcon = createIcon(Shuffle);
export const IntervalIcon = createIcon(Clock3);
export const TicketIcon = createIcon(Ticket);
export const QuestionIcon = createIcon(CircleHelp);
export const KanbanIcon = createIcon(Kanban);
export const TrashIcon = createIcon(Trash2, 14);
export const CopyIcon = createIcon(Copy, 14);
export const TextIcon = createIcon(Type);
export const DocumentIcon = createIcon(FileText);
export const ImageIcon = createIcon(Image);
export const VideoIcon = createIcon(Video);
export const AudioIcon = createIcon(Mic);
export const TimeIcon = createIcon(Clock3, 12);
export const TagsIcon = createIcon(Tags);
export const ConditionIcon = createIcon(GitBranch);
export const WebhookIcon = createIcon(Webhook);
export const TypebotIcon = createIcon(Workflow);
export const OpenAIIcon = createIcon(BrainCircuit);
export const GeminiIcon = createIcon(BrainCircuit);
export const AgentIcon = createIcon(Bot);
